import { alpha, Box, IconButton, styled, Typography } from '@mui/material';

export type IssueSeverity = 'warning' | 'error';

export const TooltipRoot = styled(Box)(({ theme }) => ({
  maxWidth: 340,
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
}));

export const MessageList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  maxHeight: 240,
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  paddingRight: theme.spacing(0.5),
}));

export const MessageCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'severity',
})<{ severity: IssueSeverity }>(({ theme, severity }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
  borderRadius: '6px',
  padding: theme.spacing(0.5, 0.25, 0.5, 1),
  backgroundColor: alpha(theme.palette[severity].main, 0.12),
  border: `1px solid ${alpha(theme.palette[severity].main, 0.22)}`,
  '&:hover .MuiTypography-root': { WebkitLineClamp: 'unset', overflow: 'visible' },
}));

export const MessageText = styled(Typography)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  color: theme.palette.text.primary,
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 4,
  overflow: 'hidden',
  cursor: 'default',
}));

export const CopyButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'severity' && prop !== 'copied',
})<{ severity: IssueSeverity; copied: boolean }>(({ theme, severity, copied }) => ({
  flexShrink: 0,
  marginTop: '-2px',
  padding: '4px',
  borderRadius: '6px',
  opacity: copied ? 1 : 0.7,
  color: theme.palette[severity].light,
  transition: theme.transitions.create(['background-color', 'color', 'opacity']),
  '&:hover': {
    opacity: 1,
    backgroundColor: alpha(theme.palette[severity].main, 0.22),
  },
}));
